import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

export const HeaderContentChip = ({ loading, ultimoPeriodo, fechaDesde, fechaHasta }) => {
    return <Box sx={{
        background: '#E0E1E3',
        padding: '10px 15px',
        marginRight: '30px',
        borderRadius: '10px',
        width: '80%',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 12
    }}>
        {loading && <CircularProgress size={20} sx={{ margin: '0 auto' }} />}
        {!loading && <>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '40%' }}>
                <strong>Último Periodo Cerrado</strong>
                <span> {ultimoPeriodo}</span>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '30%' }}>
                <strong>Fecha desde</strong>
                <span>{fechaDesde}</span>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '30%' }}>
                <strong>Fecha hasta</strong>
                <span>{fechaHasta}</span>
            </Box>
        </>}
    </Box>
}